import React, { useEffect, useState } from 'react'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import {
  PageHeader,
  CustomPanel,
  CustomCheckbox,
  Loading,
  CustomDataTableHeader,
} from '../../../../components'
import Modal from './ModalCentralOperacoes'
import { showMessageBox } from '../../../../store/actions/system.actions'
import * as CentralHttp from '../../../../services/api/https/settings/operation-center.http'

const INIT_VALUE = { id: null, name: '', actived: false }

const CentralOperacoes = ({ dispatch, history }) => {
  // Hooks
  const [isLoading, setIsLoading] = useState(true)
  const [centrais, setCentrais] = useState([])
  const [showModal, setShowModal] = useState({ show: false, data: INIT_VALUE })
  const [globalFilter, setGlobalFilter] = useState('')

  useEffect(() => {
    async function fetchCentrais() {
      try {
        const centrais = await CentralHttp.getCentralOperacoes()
        setCentrais(centrais)
      } catch (error) {
        dispatch(showMessageBox(null, error))
      } finally {
        setIsLoading(false)
      }
    }
    fetchCentrais()
  }, [setCentrais, setIsLoading])

  // Events
  const onModalSave = central => {
    setCentrais(prevCentrais => {
      const index = prevCentrais.findIndex(l => l.id === central.id)
      index !== -1 ? (prevCentrais[index] = central) : prevCentrais.push(central)
      return prevCentrais
    })
    setShowModal({ show: false, data: INIT_VALUE })
  }

  // Render
  return (
    <>
      <PageHeader>S.6 - Centrais de Operações</PageHeader>
      <div style={{ marginTop: 20 }}>
        <CustomPanel
          onNovo={() => setShowModal({ show: true, data: INIT_VALUE })}
          onVoltar={history.goBack}
        >
          {isLoading ? (
            <div className="text-center">
              <Loading size="md" />
            </div>
          ) : (
            <DataTable
              value={centrais}
              selectionMode="single"
              onSelectionChange={e => setShowModal({ show: true, data: { ...e.value } })}
              paginator
              rows={10}
              globalFilter={globalFilter}
              header={<CustomDataTableHeader onChange={setGlobalFilter} />}
            >
              <Column field="id" header="Código" style={{ textAlign: 'center', width: 80 }} />

              <Column field="name" header="Central de Operação" />
              <Column
                field="actived"
                header="Ativo"
                style={{ textAlign: 'center', width: 100 }}
                body={central => <CustomCheckbox disabled checked={central.actived} />}
              />
            </DataTable>
          )}
        </CustomPanel>
      </div>
      <Modal
        show={showModal.show}
        data={showModal.data}
        onModalClose={() => setShowModal({ show: false, data: INIT_VALUE })}
        onModalSave={onModalSave}
      />
    </>
  )
}

export default connect()(withRouter(CentralOperacoes))
